import {
  Box,
  Typography,
  FormLabel,
  TextField,
  Button,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText
} from "@mui/material";
import { useState } from "react";
import http from "../../utils/http-common";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/landing_page/Planshare.png";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import {VisibilityOutlined as VisibilityOutlinedIcon, VisibilityOffOutlined as VisibilityOffOutlinedIcon} from "@mui/icons-material/";
export const ForgotPassword = () => {
  const [screen, setScreen] = useState(1);
  const [userMail, setUserMail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [verified, setVerified] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    // Email validation
    if (!userMail) {
      tempErrors.userMail = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(userMail)) {
      tempErrors.userMail = "Email address is invalid.";
      isValid = false;
    }
    setErrors(tempErrors);
    return isValid;
  };
  const handleSubmit = () => {
    if (validateForm()) {
      Forgot_Password_1();
    }
  };
  const OtpvalidateForm = () => {
    let tempErrors = {};
    let isValid = true;

    // Name validation
    if (!otp) {
      tempErrors.otp = "Enter Otp";
      isValid = false;
    }
    // Validate newPassword only if it's present
    if (isValid){
    if (
      newPassword &&
      (newPassword.length < 6 || // Minimum 6 characters
        !/[0-9]/.test(newPassword) || // At least 1 number
        !/[!@#$%^&*]/.test(newPassword)) // At least 1 special character
    ) {
      toast.error(
        "Enter a valid password with at least 6 characters, 1 number, and 1 special character."
      );
      isValid = false;
    }
  }
  if (!newPassword){
    tempErrors.newPassword = "Enter New Password ";
  // toast.error("Please enter Password");
    isValid = false;
  } 
    if (!confirmPassword) {
       tempErrors.confirmPassword = "Enter Confirm password";
    // toast.error("Please enter Password");
      isValid = false;
    } 
    else if (newPassword !== confirmPassword) {
       tempErrors.confirmPassword = "Password and Confirm password are not same";
     // toast.error("Password and confirm password are not same");
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const ChangePassword = () => {
    if (OtpvalidateForm()) {
      Forgot_Password_2();
    }
  };
  const Forgot_Password_1 = async () => {
    try {
      // const response = await http.post('/forgot/password', JSON.stringify({
      const response = await http.post(
        "/auth_service/forgot/password",
        JSON.stringify({
          email: userMail,
          // newPassword: newPassword,
          // confirmPassword: confirmPassword
        })
      );


      if (response.data.success === true) {
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        setTimeout(() => {
          setScreen(2);
        }, 2000);
        localStorage.setItem("token", response.data.token);
      } else if (response.data.success === false) {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error verifying OTP", error);
    }
  };

  const Forgot_Password_2 = async () => {
    try {
      // const response = await http.post('/forgot/password', JSON.stringify({
      const response = await http.post(
        "/auth_service/reset/password",
        JSON.stringify({
          email: userMail,
          otp: otp,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        })
      );

      if (response.data.message === "Password reset successfully!") {
        // setScreen(0);
        // setVerified(true)
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        setTimeout(() => {
          navigate("/Login");
        }, 2000);
      } else if (response.data.success === false) {
        toast.error(response.data.message);
      }

      if (response.status === 200) {
        setOtp("");
      }
    } catch (error) {
    console.error("Error verifying OTP:", error);

    // ✅ Handle no internet / network failure
    if (error.message === "Network Error" || !error.response) {
      toast.error("No internet connection or server not reachable. Please try again later.");
      return;
    }

    // ✅ Handle timeout
    if (error.code === "ECONNABORTED") {
      toast.error("The request timed out. Please try again.");
      return;
    }

    // ✅ Handle server-side validation or unknown errors
    const serverMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error verifying OTP. Please try again.";

    toast.error(serverMessage);
  }
};
  const ResendOtp = async () => {
    try {
      // const response = await http.post('/otpverification', JSON.stringify({
      const response = await http.post(
        "/auth_service/Resend-OTP",
        JSON.stringify({
          email: userMail,
        })
      );

      if (
        response.data.message ===
          "An Email sent to your account please verify" ||
        response.status === 201
      ) {
        setOtp("");
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
      }
    } catch (error) {
      console.error("Error verifying OTP", error);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundImage: `url('./background_1.jpg')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "rgba(255, 255, 255, 0.3)", // White overlay with 50% opacity
    backgroundBlendMode: "overlay",
      }}>
      {screen === 1 && (
        <Box
          sx={{
            width: { xs: "70%", md: "27%" },
            border: "1px solid #E7E8EA",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            background: "#FFFFFF",
            borderRadius: "12px",
            p: "40px",
          }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
                src={Logo}
                alt='planshare logo'
                onClick={()=>(window.location.href = "https://planshare.ai")}
                style={{ width: "140px", height: "32px", cursor: "pointer" }}
              />
          </Box>
          <Typography
            sx={{
              my: 1,
              fontWeight: "600",
              fontSize: "20px",
              color: "#040815",
            }}>
            Forgot Your Password?
          </Typography>
          <Typography
            sx={{ fontWeight: "500", fontSize: "16px", color: "#47474799" }}>
            No worries, just enter your email, and we’ll help you reset it.
          </Typography>
          <Box
            sx={{
              my: 2,
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}>
            <FormLabel
              sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
              Email Id
            </FormLabel>
            <TextField
              placeholder='Enter Email ID'
              value={userMail}
              onChange={(e) => setUserMail(e.target.value)}
              error={!!errors.userMail}
              helperText={errors.userMail}
              sx={{
                my: 1,
                "& input": {
                  height: "10px",
                },
              }}></TextField>
            <Button
              sx={{
                my: 3,
                background: "#FF2800",
                color: "#FFFFFF",
                textTransform: "capitalize",
                fontSize: "14px",
                fontWeight: "600",
                "&:hover": {
                  background: "#e64a19",
                },
              }}
              onClick={handleSubmit}>
              Send Code
            </Button>
          </Box>
        </Box>
      )}
      {screen === 2 && (
        <Box
          sx={{
            width: { xs: "70%", md: "27%" },
            border: "1px solid #E7E8EA",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            background: "#FFFFFF",
            borderRadius: "12px",
            p: "40px",
          }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
                src={Logo}
                alt='planshare logo'
                onClick={()=>(window.location.href = "https://planshare.ai")}
                style={{ width: "140px", height: "32px", cursor: "pointer" }}
              />
          </Box>
          <Typography
            sx={{
              my: 1,
              fontWeight: "600",
              fontSize: "20px",
              color: "#040815",
            }}>
            Change Password ✨
          </Typography>
          <Typography
            sx={{ fontWeight: "500", fontSize: "16px", color: "#47474799" }}>
            We have just sent a verification code to you mail.
          </Typography>
          <Box
            sx={{
              my: 2,
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}>
            <FormLabel
              sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
              Enter Code
            </FormLabel>
            <TextField
              placeholder='Enter Code'
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\s/g, ''))}
              error={!!errors.otp}
              helperText={errors.otp}
              sx={{
                my: 1,
                "& input": {
                  height: "10px",
                },
              }}></TextField>
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                disableRipple
                sx={{
                  textDecoration: "none",
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "#040815",
                  cursor: "pointer",
                  minWidth: "max-content",
                  textTransform: "capitalize",
                }}
                onClick={ResendOtp}>
                Resend Code?
              </Button>
            </Box>
            <FormLabel
              sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
              Enter Password
            </FormLabel>
            <OutlinedInput
              placeholder='Enter Password'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              error={!!errors.newPassword}
              helperText={errors.newPassword}
              type={showPassword1 ? "text" : "password"}
              sx={{
                my: 1,
                "& input": {
                  height: "10px",
                },
              }}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={() => setShowPassword1(!showPassword1)}
                    edge='end'>
                    {showPassword1 ? (
                      <VisibilityOffOutlinedIcon />
                    ) : (
                      <VisibilityOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              label='Password'
            />
              <Box sx={{ my: 2, marginTop :-1,marginLeft :2}}>
         {errors.newPassword && (
    <FormHelperText error>{errors.newPassword}</FormHelperText>
  )}
  </Box>
            <FormLabel
              sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
              Re-Enter Password
            </FormLabel>
            <OutlinedInput
              placeholder='Re-Enter Password'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
              type={showPassword2 ? "text" : "password"}
              sx={{
                my: 2,
                "& input": {
                  height: "10px",
                },
              }}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={() => setShowPassword2(!showPassword2)}
                    edge='end'>
                    {showPassword2 ? (
                      <VisibilityOffOutlinedIcon />
                    ) : (
                      <VisibilityOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              label='Password'
            />
             <Box sx={{ my: 2, marginTop :-2,marginLeft :2}}>
         {errors.confirmPassword && (
    <FormHelperText error>{errors.confirmPassword}</FormHelperText>
  )}
  </Box>
            <Button
              sx={{
                my: 3,
                background: "#FF2800",
                color: "#FFFFFF",
                textTransform: "capitalize",
                fontSize: "14px",
                fontWeight: "600",
                "&:hover": {
                  background: "#e64a19",
                },
              }}
              onClick={ChangePassword}>
              Change Password
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};
